export default "__VITE_ASSET__f97e444b__$_?used__"